import $ from 'jquery';
import slick from 'slick-carousel';
import selectize from './selectize.jquery.js';
import popup from './popup.jquery.js';
import scroll from './scroll.js';
import header from './header.js';
import {popupFeedbackHandler, feedbackRecaptchaCallback} from './feedback.js';
import {resumeHandler, resumeRecaptchaCallback} from './resume.js';
import {popupDemoOrderHandler, demoOrderRecaptchaCallback} from './demo-lab-order.js';
import masthead from './masthead.js';
import catalogList from './catalog-list.js';
import productList from './product-list.js';
import filter from './filter.js';
import mousewheel from './vendor/jscrollpane/jquery.mousewheel.js';
//import jscollpane from './vendor/jscrollpane/jquery.jscrollpane.js';
import contact from './map.js';
import tooltip from './tooltip.js';
import bepartner from './bepartner.js';
import askQuestion from './ask-question.js';
import toggleGroup from './toggle-group.js';
import jquerySmarttab from './jquery-smarttab.js';
import videoJs from './video-js.js';
import carousel from './../../admin_assets/lib/components/carousel.js';


if ('NodeList' in window && !NodeList.prototype.forEach) {

    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

window.jQuery = window.$ = $;
window.feedbackRecaptchaCallback = feedbackRecaptchaCallback;
window.resumeRecaptchaCallback = resumeRecaptchaCallback;
window.demoOrderRecaptchaCallback = demoOrderRecaptchaCallback;

mousewheel(window.$);

require('./vendor/jscrollpane/jquery.jscrollpane.js');

$(function() {

    scroll();
    videoJs();

    $('body').on('click', 'a.js-load-more-button', function(e) {
        const url = this.getAttribute('href');

        e.preventDefault();

        if($(this).hasClass('_disabled')) {
            return;
        }

        $(this).addClass('_disabled');

        if(url.length > 1) {
            $.ajax({
                url: this.href,
                type: 'get',
                dataType: 'json',
                success: (response) => {
                    if(response) {
                        if(response.items) {
                            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                            const $wrapper = $(this).closest('.list').find('.list__wrapper');

                            $wrapper.children('._fake').remove()
                            $wrapper.append(response.items);

                            window.scrollTo(0, scrollTop);
                        }

                        if(response.next_page_url) {
                            this.href = response.next_page_url;
                        }
                        else {
                            this.parentElement.removeChild(this);
                        }
                    }

                    $(this).removeClass('_disabled');
                },
                error: () => {
                    $(this).removeClass('_disabled');
                }
            })
        }
        else {
            this.parentElement.removeChild(this);
        }
    });

    $('body').find('iframe[src*="youtube.com"]').each((idx, item) => {
        const width = parseInt(item.width);
        const height = parseInt(item.height);

        if(!isNaN(width) && !isNaN(height)) {
            const ratio = height / (width/100);

            $(item).wrap(`<div class="iframe-wrapper"></div>`);
            $(item).before(`<span class="iframe-wrapper__push" style="margin-top: ${ratio}%"></span>`);

        }
    })


    header();
    carousel.boot();


    $('.selectize').selectize();

    contact();
    catalogList();
    productList();
    filter();
    tooltip();
    bepartner();
    askQuestion();
    popupFeedbackHandler($('#feedback_popup'));
    resumeHandler($('#resume_block'));

    if ($('#demo_order_popup').length) {
        popupDemoOrderHandler($('#demo_order_popup'));
    }

    toggleGroup();
    jquerySmarttab();

    if(document.readyState === 'complete') {
        masthead();
    }
    else {
        window.onload = function() {
            masthead();
        };
    }
});

$(document).ready(function() {
    // Функция для привязки recaptcha-id к элементам reCAPTCHA
    function storeRecaptchaIds() {
        $('.g-recaptcha').each(function(index, element) {
            // Id соответствует порядку элементов на странице
            $(element).data('recaptcha-id', index); // Сохраняем в data атрибуте
        });
    }

    // Ждём загрузки reCAPTCHA
    setTimeout(storeRecaptchaIds, 500); // Небольшая задержка для рендеринга
});
